export const PROJECTLIST_MUTATION = "PROJECTLIST_MUTATION";
